import _implicitStylesheets from "./radioGroup.css";
import _implicitScopedStylesheets from "./radioGroup.scoped.css?scoped=true";
import _wdsStarRatings from "wds/starRatings";
import _axBadge from "ax/badge";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="label-required${0}"${2}>*</span>`;
const $fragment2 = parseFragment`<span${3}>${"t1"}</span>`;
const $fragment3 = parseFragment`<span class="description${0}"${2}>${"t1"}</span>`;
const $fragment4 = parseFragment`<div class="showError${0}"${2}>${"t1"}</div>`;
const stc0 = {
  classMap: {
    "label": true
  },
  key: 1
};
const stc1 = {
  attrs: {
    "grid": "",
    "axis": "column",
    "row-gap": "small"
  },
  key: 4
};
const stc2 = {
  "type": "filter"
};
const stc3 = {
  "item_label": true
};
const stc4 = {
  classMap: {
    "items": true
  },
  key: 9
};
const stc5 = {
  classMap: {
    "star-items": true
  },
  key: 14
};
const stc6 = {
  "star-rating": true,
  "item_label": true
};
const stc7 = {
  slotAssignment: "label",
  key: 16
};
const stc8 = {
  classMap: {
    "badge-item": true
  },
  key: 17
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, d: api_dynamic_text, t: api_text, st: api_static_fragment, h: api_element, k: api_key, gid: api_scoped_id, b: api_bind, sp: api_static_part, c: api_custom_element, i: api_iterator} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5} = $ctx;
  return [api_element("fieldset", {
    className: api_normalize_class_name($cmp.stateClassName),
    key: 0
  }, [$cmp.label ? api_element("legend", stc0, [api_text(api_dynamic_text($cmp.label)), $cmp.required ? api_static_fragment($fragment1, 3) : null]) : null, api_element("div", stc1, api_iterator($cmp.radioOptions, function (item) {
    return api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
      props: stc2,
      key: api_key(5, item.value)
    }, [api_element("div", {
      className: api_normalize_class_name($cmp.inputType),
      attrs: {
        "data-value": item.value
      },
      key: 6
    }, [api_element("input", {
      attrs: {
        "aria-label": item.label,
        "type": $cmp.inputType,
        "id": api_scoped_id(item.value),
        "name": $cmp.name
      },
      props: {
        "checked": item.checked,
        "value": item.value
      },
      key: 7,
      on: {
        "mouseup": _m0 || ($ctx._m0 = api_bind($cmp.handleMouseUp)),
        "change": _m1 || ($ctx._m1 = api_bind($cmp.handleChange)),
        "focus": _m2 || ($ctx._m2 = api_bind($cmp.handleFocus)),
        "blur": _m3 || ($ctx._m3 = api_bind($cmp.handleBlur)),
        "click": _m4 || ($ctx._m4 = api_bind($cmp.handleClick))
      }
    }), api_element("label", {
      classMap: stc3,
      attrs: {
        "for": api_scoped_id(item.value)
      },
      key: 8,
      on: {
        "mouseup": _m5 || ($ctx._m5 = api_bind($cmp.handleMouseUp))
      }
    }, [item.isBaseLabel ? api_element("div", stc4, [api_static_fragment($fragment2, 11, [api_static_part(1, null, api_dynamic_text(item.label))]), item.description ? api_static_fragment($fragment3, 13, [api_static_part(1, null, api_dynamic_text(item.description))]) : null]) : null, item.stars ? api_element("div", stc5, [api_custom_element("wds-star-ratings", _wdsStarRatings, {
      classMap: stc6,
      props: {
        "value": item.stars,
        "spaceBetween": "none",
        "size": "small",
        "labelPosition": "right",
        "readOnly": true
      },
      key: 15
    }, [api_element("span", stc7, [api_text(api_dynamic_text(item.starsLabel))])])]) : null, item.badge ? api_element("div", stc8, [api_custom_element("ax-badge", _axBadge, {
      props: {
        "theme": item.badge.variant,
        "text": item.label
      },
      key: 18
    })]) : null])])]);
  }))]), $cmp._errorMessage ? api_static_fragment($fragment4, 20, [api_static_part(1, null, api_dynamic_text($cmp._errorMessage))]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-37c0cu1pdiu";
tmpl.legacyStylesheetToken = "undefined-_radioGroup";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
